import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { gql } from '@apollo/client'
import { SET_PASSWORD_MUTATION } from '../../graphql'
import ChangePasswordForm from '../ChangePasswordForm/ChangePasswordForm'
import MessageCard from '../MessageCard/MessageCard'

const SET_PASSWORD = gql(SET_PASSWORD_MUTATION)

export default function ResetPassword(props) {
  const { userId } = props
  console.log('ResetPassword rendered', props)

  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)
  const navigate = useNavigate()

  function cancelClicked() {
    navigate('/login')
  }

  function savePassword(newPassword) {
    window.apolloClient.mutate({ mutation: SET_PASSWORD, variables: { userId: userId, newPassword: newPassword } })
      .then(result => {
        setSuccess(true)
      })
      .catch(error => {
        setError(error.message)
      })
  }

  if (success) {
    return (
      <MessageCard
        title="Password Reset"
        message="Your password has been successfully reset."
        buttonText="Login"
        clickUrl="/login"
      />
    )
  }
  return (
    <ChangePasswordForm
      savePassword={savePassword}
      saveError={error}
      cancelClicked={cancelClicked}
      actionButtonText='Reset Password'
    />
  )
}